<template>
  <div>
    <div class="order_list">
      <div class="top_space"/>
      <div class="label_title">
        查詢訂單
      </div>
      <div class="info_area">
        <div style="height: 48px;"/>
        <div class="row no-gutters input_area align-items-baseline">
          <div class="text_label">請輸入訂單編號</div>
          <div class="text_label_space"/>
          <div class="col" style="min-height: auto">
            <input class="input_style" v-model="order.num" placeholder="請輸入訂單編號 ex:A123456"
                   @blur="validateNull('name')"/>
            <div v-if="isNotEmpty(errors.num)" class="error-message">{{ errors.num }}</div>
          </div>
        </div>
        <div style="height: 32px;"/>

        <div class="btn_area">
          <button type="button" class="btn btn_style btn-primary" @click="clickCheck">
            <span class="btn_text">查詢</span>
          </button>
        </div>
        <div style="height: 32px;"/>

        <div class="notice_area">
          <div class="title">注意事項</div>
          <div style="height: 4px"/>
          <div class="info">1.訂單資訊已寄信至訂購人電子信箱。</div>
          <div style="height: 4px"/>
          <div class="info">2.至「查詢訂單」頁面，輸入訂單編號可以查詢訂單寄送狀態。</div>
          <div style="height: 4px"/>
          <div class="info">3.完成結帳後，訂單寄送狀態會同步寄信至訂購人電子信箱。</div>
          <div style="height: 4px"/>
          <div class="info">4.登入Line可以第一時間收到訂單寄送狀態通知</div>
          <div style="height: 4px"/>
          <div class="info">5.如有任何問題請透過以下方式聯繫客服。</div>
        </div>
        <div style="height: 24px;"/>
        <div class="divider"/>
        <div style="height: 32px;"/>
        <div class="down_area">
          <div class="row align-items-center no-gutters">
            <button type="button" class="btn btn_icon_style" @click="clickBtn('instagram')">
              <img src="/img/image/icon/ig.png" class="icon" loading="lazy" alt="instagram"/>
            </button>
            <div class="icon_space"/>
            <button type="button" class="btn btn_icon_style" @click="clickBtn('line')">
              <img src="/img/image/icon/line.png" class="icon" loading="lazy" alt="Line"/>
            </button>
          </div>
        </div>
        <div style="height: 12px"/>
      </div>
      <div class="down_space" style="height: 65px;"/>
    </div>
    <Loading/>
  </div>
</template>

<script>
import {checkError, isEmpty} from "../util/helpers";
import {getOrderDetail} from "../api/api";
import AlertDialog from "./dialog/AlertDialog";
import Loading from "./dialog/Loading";

export default {
  name: "Search",
  components: {Loading},
  data() {
    return {
      order: {
        num: "",
      },
      errors: {
        num: '',
      }
    };
  },
  computed: {
    settingData() {
      return this.$store.getters.getSettingData;
    },
    instagramUrl() {
      let val = this.settingData.data.url_instagram;
      return isEmpty(val) ? '' : val;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
    facebookUrl() {
      let val = this.settingData.data.url_facebook;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    isNotEmpty(val) {
      return isEmpty(val) === false;
    },
    validateNull(type) {
      switch (type) {
        case "num" :
          if (isEmpty(this.order.num)) {
            this.errors.num = '*您尚未填寫資料';
          } else {
            this.errors.num = '';
          }
          break;
      }
    },
    areAllErrorsEmpty() {
      return Object.values(this.errors).every(value => isEmpty(value));
    },
    async clickCheck() {
      this.validateNull('num');
      let result = this.areAllErrorsEmpty();
      if (result === false) return;
      try {
        await this.$store.dispatch('showLoading');
        let response = await getOrderDetail(this.order.num.trim());
        if (await checkError(this.$dialog, response)) {
          if (isEmpty(response.data)) {
            await this.$store.dispatch('hideLoading');
            await this.$dialog.show(AlertDialog, {text: "找不到訂單"})
          } else {
            let order = response.data;
            let trade_no = response.data.trade_no;
            await this.$store.dispatch('hideLoading');
            await this.$router.push({path: '/orderDetail', query: {trade_no: trade_no}});
          }
        }
      } catch (e) {
        console.log('error', e);
      }
    },
    clickBtn(type) {
      switch (type) {
        case "line":
          window.open(this.lineUrl, '_blank');
          return;
        case "instagram":
          window.open(this.instagramUrl, '_blank');
          return;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order_list {
  width: 1120px;
  margin: 0 auto;
}

@media (max-width: 1440px) {
  .order_list {
    width: 77vw;
  }
}

@media (max-width: 1024px) {
  .order_list {
    width: 90vw;
  }
}

@media (max-width: 768px) {
  .order_list {
    width: 100%;
  }
}

.top_space, .down_space {
  height: 65px;
}

@media (max-width: 1024px) {
  .top_space, .down_space {
    height: 32px;
  }
}

@media (max-width: 768px) {
  .top_space, .down_space {
    height: 0;
  }
}


.label_title {
  background-color: #333333;
  padding: 10px 24px 10px 24px;
  color: white;
  font-size: 20px;
  font-weight: 500;
}

.commodity_label {

}

@media (max-width: 768px) {
  .commodity_label {
    height: 0;
    visibility: hidden;
  }
}

.commodity_label_space {
  height: 24px;
}

@media (max-width: 768px) {
  .commodity_label_space {
    height: 0;
  }
}


.order_list .info_area {
  padding-left: 24px;
  padding-right: 24px;
}

@media (max-width: 1024px) {
  .order_list .info_area {
    padding-left: 16px;
    padding-right: 16px;
  }
}


.info_area {
  background-color: #FAFAFA;
}


.text_style {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.input_area {
  width: 545px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .input_area {
    flex-direction: column;
    //height: 64px;
  }
}

@media (max-width: 768px) {
  .input_area {
    width: 77vw;
  }
}


.text_label {
  max-width: 160px;
  width: 160px;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 768px) {
  .text_label {
    margin: 0 auto;
  }
}

@media (max-width: 425px) {
  .text_label {
    width: auto;
  }
}

.text_label_space {
  width: 20px;
}

@media (max-width: 768px) {
  .text_label_space {
    width: 0;
    height: 12px;
  }
}


.input_style {
  font-family: Noto Sans TC;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding: 12px;
  //border-radius: 5px;
  border: 0.5px solid #DDE1E9;
  resize: none; /* 禁用用户调整大小 */
  overflow: auto; /* 确保超出内容时可以滚动 */
  width: 100%;
}

.input_style::placeholder {
  color: #888;
}


.error-message {
  color: #D60404;
  font-size: 18px;
  margin-top: 8px;
  margin-left: 8px;
}

@media (max-width: 425px) {
  .error-message {
    margin-top: 4px;
    margin-left: 4px;
    font-size: 16px;
  }
}

.divider {
  width: auto;
  height: 1px;
  background-color: #D56835;
}


.notice_area {
  padding-left: 72px;
  padding-right: 72px;
}

@media (max-width: 768px) {
  .notice_area {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 425px) {
  .notice_area {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media (max-width: 360px) {
  .notice_area {
    padding-left: 16px;
    padding-right: 16px;
  }
}


.notice_area .title {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 768px) {
  .notice_area .info {
    font-size: 18px;
  }
}

@media (max-width: 425px) {
  .notice_area .title {
    font-size: 16px;
  }
}

.notice_area .info {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 425px) {
  .notice_area .info {
    font-size: 14px;
  }
}


.btn_area {
  text-align: center;
}

@media (max-width: 425px) {
  .btn_area {
    padding: 0;
    margin: 0;
  }
}

.btn_style {
  width: 230px;
  height: 56px;
  line-height: 0;
}

@media (max-width: 700px) {
  .btn_style {
    width: 200px;
    height: 48px;
  }
}

@media (max-width: 425px) {
  .btn_style {
    width: 120px;
    height: 32px;
  }
}

.btn_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: white;
}

@media (max-width: 425px) {
  .btn_text {
    line-height: 0;
    font-weight: 500;
    font-size: 16px;
  }
}

.down_area {
  padding-left: 24px;
  padding-right: 24px;
  height: 36px;
}

@media (max-width: 768px) {
  .down_area {
    padding-left: 60px;
    padding-right: 24px;
  }
}

@media (max-width: 360px) {
  .down_area {
    padding-left: 24px;
    padding-right: 16px;
  }
}

.icon_space {
  width: 20px;
}

.btn_icon_style {
  padding: 0;
  margin: 0;
  border-radius: 50%;
  width: 36px;
  height: 36px
}

.icon {
  width: 36px;
  height: 36px
}

</style>
